import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/WhatsAppMarketingTool';
import AuthWrapper from './components/AuthWrapper';
import ExampleComponent from './components/ExampleComponent';
import './styles/app.css';
import LoginPage from './pages/login/Login';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="" element={<AuthWrapper><Home /></AuthWrapper>} />
          <Route path="/example" element={<ExampleComponent />} />
          {/* <Route path="" element={<LoginPage />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;